import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UserDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface ReactivateUserApiResponse {
  success: boolean;
  data: UserDto;
}

/**
 * Mutation hook for reactivating a deactivated user.
 * Calls POST /users/:id/reactivate.
 */
export function useReactivateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      const response = await apiClient.post<ReactivateUserApiResponse>(`/users/${id}/reactivate`);
      return response.data.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.users.list() });
      queryClient.invalidateQueries({ queryKey: queryKeys.users.byId(data.id) });
    },
  });
}
